import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";

type Plan = "free" | "junior" | "senior";

type ScheduledArticle = {
  id?: string;
  date: Date;
  suggestedTopic: string;
};

interface RecommendedScheduleProps {
  plan?: Plan;
  schedules?: ScheduledArticle[];
}

export function RecommendedSchedule({ schedules }: RecommendedScheduleProps) {
  const [schedule, setSchedule] = useState<ScheduledArticle[]>([]);
  
  useEffect(() => {
    // Only use provided schedules, don't generate static data
    if (schedules) {
      setSchedule(schedules);
    } else {
      setSchedule([]);
    }
  }, [schedules]);

  return (
    <Card className="h-full flex flex-col">
      <CardHeader>
        <CardTitle>Content Pipeline</CardTitle>
      </CardHeader>
      <CardContent className="flex-1 overflow-auto">
        <div className="space-y-4">
          {schedule.length > 0 ? schedule.map((article, index) => (
            <div
              key={article.id || index}
              className="flex items-center justify-between p-4 rounded-lg border hover:bg-accent/5 transition-colors"
            >
              <div className="flex items-start gap-3">
                <div className="mt-0.5">
                  <FontAwesomeIcon
                    icon={faFileLines}
                    className="h-[18px] w-[18px] text-muted-foreground"
                  />
                </div>
                <div>
                  <p className="font-medium">{article.suggestedTopic}</p>
                  <p className="text-sm text-muted-foreground">
                    {format(article.date, "EEEE, MMM dd, yyyy")}
                  </p>
                </div>
              </div>
            </div>
          )) : (
            <div className="flex flex-col items-center justify-center h-[250px] text-center">
              <p className="text-muted-foreground">No scheduled content yet</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
